<template>
  <div class="main-page-box">
    <h5>这是Add的页面</h5>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {

      }

    },
    components: {

    },
    methods: {

    },
    mounted() {

    }
  }
</script>
<style scoped>

</style>
